import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/customer_file",
  component: function component() {
    return import("../../../views/member/customer-file/index.vue");
  },
  name: "customer_file",
  meta: {
    title: "顾客档案",
    foot: true
  }
}, {
  path: "/customer_life_fill_in",
  component: function component() {
    return import("../../../views/member/customer-file/fill-in.vue");
  },
  name: "customer_life_fill_in",
  meta: {
    title: "填写资料",
    foot: true
  }
}, {
  path: "/customer_life_info/:id?",
  component: function component() {
    return import("../../../views/member/customer-file/info.vue");
  },
  name: "customer_life_info",
  meta: {
    title: "客户信息",
    foot: true
  }
}, {
  path: "/customer_life_edit/:id?",
  component: function component() {
    return import("../../../views/member/customer-file/edit.vue");
  },
  name: "customer_life_edit",
  meta: {
    title: "修改资料",
    foot: true
  }
}, {
  path: "/customer_life_project/:id?/:customer_archive_id?",
  component: function component() {
    return import("../../../views/member/customer-file/project.vue");
  },
  name: "customer_life_project",
  meta: {
    foot: true
  }
}];